<script setup lang="ts">
import { computed } from 'vue';
import { BTextField, BBtnIcon } from '@/design-system';
import { useTranslation } from '@/composables';

type PropsType = {
    label?: string;
    loading?: boolean;
    isLabelTranslated?: boolean;
    name?: string;
};

withDefaults(defineProps<PropsType>(), { isLabelTranslated: true });

const emit = defineEmits<{
    clear: [];
}>();

const modelValue = defineModel<string | null>({ required: true });

const { t } = useTranslation();

const hintText = computed(() => {
    if (modelValue.value) {
        return `${t('companies.selectedColor')}: ${modelValue.value}`;
    }

    return `${t('companies.selectedColor')}: ${t('common.none')}`;
});
</script>

<template>
    <div class="d-flex align-start gap-2">
        <BTextField
            v-model="modelValue"
            type="color"
            :name="name"
            :label="label"
            prepend-icon="mdi-palette"
            :loading="loading"
            :is-label-translated="isLabelTranslated"
            :hint="hintText"
            :persistent-hint="true"
            class="flex-grow-1"
        />
        <div class="color-clear-btn-container d-flex align-center mt-2">
            <BBtnIcon
                v-if="modelValue"
                icon="mdi-close"
                :tooltip="t('common.clear')"
                color="error"
                @click="emit('clear')"
            />
        </div>
    </div>
</template>

<style scoped>
.color-clear-btn-container {
    min-width: 40px;
}
</style>
